import type { App } from "vue";

/** Antd 组件按需引入 */

import {
  Button,
  Modal,
  Table,
  Menu,
  Input,
  Form,
  Card,
  Checkbox,
  Radio,
  Col,
  Row,
  Select,
  DatePicker,
  Switch,
  Tag,
  Dropdown,
  InputNumber,
  TreeSelect,
  Tooltip,
  List,
  Layout,
  Image,
  Divider,
  Pagination,
  Drawer,
  Collapse,
  Tabs,
  Popover,
  Spin,
  Popconfirm,
  Tree,
  Transfer,
  Upload
} from "ant-design-vue";

import "ant-design-vue/dist/antd.css";

export function setupAntd(app: App<Element>) {
  app
    .use(Button)
    .use(Form)
    .use(Input)
    .use(Modal)
    .use(Table)
    .use(Menu)
    .use(Card)
    .use(Checkbox)
    .use(Radio)
    .use(Col)
    .use(Row)
    .use(Select)
    .use(DatePicker)
    .use(Switch)
    .use(Tag)
    .use(Dropdown)
    .use(InputNumber)
    .use(TreeSelect)
    .use(Tooltip)
    .use(List)
    .use(Layout)
    .use(Image)
    .use(Divider)
    .use(Pagination)
    .use(Drawer)
    .use(Collapse)
    .use(Tabs)
    .use(Spin)
    .use(Popconfirm)
    .use(Popover)
    .use(Tree)
    .use(Transfer)
    .use(Upload);
}
